import React, { ReactElement } from 'react'
import { DisableDates } from '../Datepicker'

import { Mode } from '../enums'

interface IProps {
  mode: Mode
  values: any[]
  selectedDate: Date
  elements?: ReactElement[]
  columns: number
  disableDates?: DisableDates
  disableFull: boolean
  disableAgainst?: Date
  onClick: (value: number) => void
}

const ModeElements = (props: IProps) => {
  let totalSlots = props.elements || []
  const keyStart = props.elements ? props.elements.length : 0
  let selected: number
  let disableDate: Date

  const tdElements: ReactElement[] = props.values.map((td: string | number, index: number) => {
    if (props.mode === Mode.Day) {
      selected = props.selectedDate.getDate()
      disableDate = new Date(
        props.selectedDate.getFullYear(),
        props.selectedDate.getMonth(),
        props.values[index] as number
      )
    } else if (props.mode === Mode.Month) {
      selected = props.values[props.selectedDate.getMonth()]
      disableDate = new Date(props.selectedDate.getFullYear(), index, props.selectedDate.getDate())
    } else {
      selected = props.selectedDate.getFullYear()
      disableDate = new Date(td as number, props.selectedDate.getMonth(), props.selectedDate.getDate())
    }

    const tdProps = {
      key: keyStart + index,
      className: 'cs-rdatepicker__table-cell',
      onClick: () => props.onClick(index)
    }

    let invalidDate: boolean = false

    if (props.disableDates) {
      invalidDate = props.disableDates.apply(this, [disableDate])
    }

    if (selected === props.values[index]) {
      tdProps.className = 'cs-rdatepicker__table-cell--selected'
    }

    if (invalidDate && props.disableFull) {
      tdProps.className = 'cs-rdatepicker__table-cell--disabled'
      // @ts-ignore
      delete tdProps.onClick
    }

    return <td {...tdProps}>{td}</td>
  })

  totalSlots = totalSlots.concat(tdElements)

  const rows: ReactElement[][] = []
  let cells: ReactElement[] = []

  totalSlots.forEach((row: ReactElement, i: number) => {
    if (i % props.columns !== 0) {
      cells.push(row)
    } else {
      if (i !== 0) {
        rows.push(cells)
      }
      cells = []
      cells.push(row)
    }
    if (i === totalSlots.length - 1) {
      rows.push(cells)
    }
  })

  return (
    <tbody>
      {rows.map((tds: ReactElement[], i: number) => (
        <tr key={i}>{tds}</tr>
      ))}
    </tbody>
  )
}

export default ModeElements
